import { Route, Switch } from "react-router-dom";
import IdentifyingOpeningSoonRetailersOnBrandPortalPage from "@faire/prototype-playground/workspace/hyd/identifying-opening-soon-retailers-on-brand-portal";
import SignupStoreInfoOptionsPage from "@faire/prototype-playground/workspace/hyd/signup-store-info-options";

export function HaoyangDingRoutes() {
  return (
    <Switch>
      <Route path="/hyd/identifying-opening-soon-retailers-on-brand-portal" component={IdentifyingOpeningSoonRetailersOnBrandPortalPage} />
      <Route path="/hyd/signup-store-info-options" component={SignupStoreInfoOptionsPage} />
    </Switch>
  );
}

export const slug = "hyd";
